/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_ReservedInputs */

const cs_enum_reserved = /** @type {(inputs: Enum_ReservedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezervováno`)
};

const en_enum_reserved = /** @type {(inputs: Enum_ReservedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reserved`)
};

/**
* | output |
* | --- |
* | "Reserved" |
*
* @param {Enum_ReservedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_reserved = /** @type {((inputs?: Enum_ReservedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_ReservedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_reserved(inputs)
	return cs_enum_reserved(inputs)
});